import axios from "axios"
import { CONST_API_CLIENT_PTF_GET_LISTING_ENDPOINT } from "../../../../../endpoints"
import { IGetPropositionsRequestModel, IGetPropositionsResponseModel } from "./_models"

export function getPropositionsListing(payload: IGetPropositionsRequestModel) {
     return axios.post<IGetPropositionsResponseModel>(CONST_API_CLIENT_PTF_GET_LISTING_ENDPOINT, payload)
}
